import { apiRequest } from '../../../helpers/apiRequest/apiRequest';
import { appLogout } from '../../../helpers/getAuthorizedState/getAuthorizedState';
import { rollbar, logErrorFromPromise } from '../../../components/RollbarConfig/RollbarConfig';
import { NOTIFICATION_TYPE, SOMETHING_WENT_WRONG } from '../../../constants/CONSTANTS';

/**
 * To reset activity
 * @param {string} studentId
 * @param {string} activityReferenceId
 * @param {context} notificationContext
 */
export const resetActivity = (studentId, activityReferenceId, notificationContext) => {
  const url = `${process.env.REACT_APP_DSW_API_URL}reset/student/${studentId}`;
  const requestData = {
    body: JSON.stringify({ activityReferenceId })
  };
  return apiRequest('POST', url, requestData).then((response) => {
    if (response && response.status === 401) {
      appLogout();
    }
    if (response && response.status === 400) {
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
      logErrorFromPromise(response.json());
    }
  }).catch((response) => {
    notificationContext.setNotificationState({
      type: NOTIFICATION_TYPE.ATTENTION,
      title: SOMETHING_WENT_WRONG,
      message: ''
    });
    rollbar.error(response);
  });
};

/**
 * To get review lesson
 * @param {string} studentId
 * @param {string} lessonId
 * @param {context} notificationContext
 * @param {context} loaderContext
 */
export const getReviewLesson = (studentId, lessonId, notificationContext, loaderContext) => {
  loaderContext.enableLoader(true);
  const url = `${process.env.REACT_APP_DSW_API_URL}student/${studentId}/review/lesson/${lessonId}`;
  return apiRequest('GET', url).then((response) => {
    loaderContext.enableLoader(false);
    if (response && response.status === 401) {
      appLogout();
    }
    if (response && response.status === 400) {
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
      logErrorFromPromise(response.json());
    }
    return response.json();
  }).catch((response) => {
    loaderContext.enableLoader(false);
    notificationContext.setNotificationState({
      type: NOTIFICATION_TYPE.ATTENTION,
      title: SOMETHING_WENT_WRONG,
      message: ''
    });
    rollbar.error(response);
  });
};
